import type { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import type { PersonGroupMembership } from '@/types/community';
import type RepositoryResponse from '@/types/repositoryResponse';
import ajax from '@/utils/ajax';
import logAjaxError from '@/utils/logAjaxError';

export const communityRepository = {
  async getPersonGroupMemberships({
    host,
    personId
  }: {
    host: string;
    personId: string;
  }): Promise<RepositoryResponse<PersonGroupMembership[]>> {
    try {
      const path = `/api/dugout/community/${personId}/groups`;
      const response = await ajax.get({
        url: `${host}${path}`
      });

      return {
        data: response.data,
        isError: false
      };
    } catch (error) {
      logAjaxError(error);

      return {
        errorMessage: `Failed to get community data: ${(error as AxiosError).message}`,
        error: error as AxiosError,
        isError: true
      };
    }
  }
};

const CommunityRepository = () => {
  const { host } = useContext(AppContext);
  return {
    async getPersonGroupMemberships({
      personId
    }: {
      personId: string;
    }): Promise<RepositoryResponse<PersonGroupMembership[]>> {
      return communityRepository.getPersonGroupMemberships({ host, personId });
    }
  };
};

export default CommunityRepository;
